import React, { useContext, useRef, useEffect } from 'react';
import { s as styleInject } from '../../style-inject.es-746bb8ed.js';
import { mergeStyles } from 'wix-rich-content-common';
import { FocusManager } from 'wix-rich-content-ui-components';
import { RicosContext } from 'ricos-context';

var css_248z = "._8IsMg,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.TBxWb{align-items:flex-start;align-items:center;display:flex;flex-direction:column;width:100%}[dir] .TBxWb{padding:8px 0}";
var Styles = {"fontElementMap":"_8IsMg","desktopPanel":"TBxWb"};
styleInject(css_248z);

const DesktopPanel = ({ options, externalFocus }) => {
  const { theme } = useContext(RicosContext) || {};
  const styles = mergeStyles({ styles: Styles, theme });
  const panelRef = useRef(null);
  useEffect(() => {
    const ref = panelRef.current;
    !externalFocus && setTimeout(() => ref.focus(), 0);
  }, []);
  const dropDownPanel = /* @__PURE__ */ React.createElement(
    "div",
    {
      tabIndex: 0,
      ref: panelRef,
      "data-hook": "toolbars-modal-desktopPanel",
      className: styles.desktopPanel
    },
    options
  );
  return externalFocus ? dropDownPanel : /* @__PURE__ */ React.createElement(FocusManager, null, dropDownPanel);
};

export { DesktopPanel as default };
//# sourceMappingURL=DesktopPanel.js.map
